import { ModelBase } from '../../core/model/model-base';
import { EmailDeliveryStatus, EmailDeliveryStatusToString } from '../../message/model/const/enums';
import { InvoiceDeliveryMethod } from './const/enum';

export class InvoiceDelivery extends ModelBase {
  constructor() {
    super();
    Object.defineProperties(this, {
      _createdDate: { enumerable: false, writable: true },
      _sentDate: { enumerable: false, writable: true },
    });
  }

  private _createdDate: Date;
  private _sentDate: Date;

  get createdDate(): Date {
    return this._createdDate;
  }
  set createdDate(value: Date) {
    this._createdDate = this.coerceDate(value);
  }

  get sentDate(): Date {
    return this._sentDate;
  }
  set sentDate(value: Date) {
    this._sentDate = this.coerceDate(value);
  }

  deliveryStatus: EmailDeliveryStatus;
  deliveryInfo: string;

  get deliveryStatusText(): string {
    if (this.deliveryStatus === undefined || this.deliveryMethod === undefined) return null;
    if (this.deliveryMethod === InvoiceDeliveryMethod.EmailWithoutPDF || this.deliveryMethod === InvoiceDeliveryMethod.EmailWithPDF)
      return EmailDeliveryStatusToString(this.deliveryStatus);
    return null;
  }

  invoiceDeliveryMethodText: string;

  deliveryMethod: InvoiceDeliveryMethod;
}
